import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const SuccessSnackbar = ({ open, message, onClose, autoHideDuration = 4000 }) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <Alert
      severity="success"
      sx={{
        backgroundColor: '#4caf50',
        color: 'white',
        fontWeight: 600,
        fontSize: '1rem',
        '& .MuiAlert-icon': { color: 'white' },
        '& .MuiAlert-message': { color: 'white' },
        '& .MuiAlert-action': { color: 'white' },
      }}
      onClose={onClose}
    >
      <span style={{ color: 'white' }}>
        ✅ {message}
      </span>
    </Alert>
  </Snackbar>
);

export default SuccessSnackbar;
